<template>
  <b-sidebar
    v-model="modalOpen"
    v-if="modalOpen"
    centered
    id="branchModal"
    class="edit-modal"
    width="500px"
    backdrop
    no-close-on-backdrop
    no-close-on-esc
    no-header
    body-class="bg-white"
  >
    <div class="p-2">
      <validation-observer ref="branchValidation">
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col class="d-flex justify-content-between" cols="12">
              <h3> {{ mainTitle }} </h3>
              <feather-icon
                size="20"
                class="cursor-pointer"
                @click="modalOpen = false"
                icon="XIcon"
              />
            </b-col>
            <b-col cols="12">
              <hr />
            </b-col>
            <b-col cols="12">
              <form-select
                rules="required"
                label="رقم محضر الجلسة الإدارية الي تمّ خلالها الموافقة على الانضمام / الانتساب"
                id="meeting_minute"
                v-model="form.meeting_minute_id"
                :getOptionLabel="(x) => x.meeting_minutes_label"
                :reduce="(x) => x"
                ep="v2/selects/meeting-minutes"
              />
              
              <small class="text-secondary mb-1 d-block" style="margin-top: -10px;">
                في حال عدم وجود محضر الاجتماع يُرجى تقديم معاملة بالمحضر الجديد
              </small>
            </b-col>
            <b-col cols="12">
              <form-input
                label="اسم المنظمة الدولية"
                v-model="form.name"
                rules="required"
              />

            </b-col>
            <b-col cols="12">
              <form-select
                rules="required"
                label="الدولة"
                id="country"
                v-model="form.country_id"
                :reduce="(x) => x"
                :getOptionLabel="(x) => x.name"
                ep="v2/guest/selects/countries"
              />
            </b-col>
            <b-col cols="12">
              <form-input
                v-model="form.address"
                rules="required"
                label="عنوان مقر المنظمة الدولية"
              />
            </b-col>
            <b-col cols="12">
              <form-input
                label="مجال عمل المنظمة الدولية"
                v-model="form.field_of_work"
                rules="required"
              />

            </b-col>
            <b-col cols="12">
              <form-input
                label="كافة البيانات المتوفرة لدى المنظمة غير حكومية حول المنظمة لدولية"
                v-model="form.international_organization_data"
                rules="required"
              />

            </b-col>
            <b-col cols="12">

              <b-form-group label="أهداف المنظمة الدولية" label-for="details">
                <validation-provider
                  #default="{ errors }"
                  name="أهداف المنظمة الدولية"
                  rules="required"
                  id="details"
                  mode="passive"
                >
                  <quill-editor
                    :options="editorOption"
                    v-model="form.international_organization_goals"
                    :class="{ quillEditor: errors.length > 0 }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col  cols="12 " class="mt-2">
              <div>
                <p>
                  المُرفقات :
                </p>
              </div>
              <hr />
            </b-col>
            
            <b-col cols="12">
              <label for="email-to" class="form-label"> صورة عن الدعوة الموجهة للمنظمة الغير حكومية من قبل المنظمة الدولية للانضمام </label>
              <form-file-input
                placeholder="اختر الملف"
                id="document"
                v-model="form.invitation_doc"
                rules="required"
                accept=".pdf"
              />
            </b-col>
            <b-col cols="12">
              <label for="email-to" class="form-label"> صك إحداث المنظمة الدولية </label>
              <form-file-input
                placeholder="اختر الملف"
                id="document"
                v-model="form.charter_doc"
                rules="required"
                accept=".pdf"
              />
            </b-col>
            <b-col cols="12">
              <label for="email-to" class="form-label"> النظام الداخلي للمنظة الدولية </label>
              <form-file-input
                placeholder="اختر الملف"
                id="document"
                v-model="form.internal_system_doc"
                rules="required"
                accept=".pdf"
              />
            </b-col>
            <b-col cols="12">
              <label for="email-to" class="form-label"> كتاب مُقدم من المنظمة الدولية يوضح فيه أعضاء إدارتها و أنشطتها و أماكن انتشارها و مصادر تمويلها وأعضاء المنظمة  </label>
              <form-file-input
                placeholder="اختر الملف"
                id="document"
                v-model="form.activities_and_funding_doc"
                rules="required"
                accept=".pdf"
              />
            </b-col>
            <b-col cols="12">
              <label for="email-to" class="form-label"> صور جوازات سفر أعضاء إدارة المنظمة الدولية </label>
              <form-file-input
                placeholder="اختر الملف"
                id="document"
                v-model="form.passports_doc"
                rules="required"
                accept=".pdf"
              />
            </b-col>
            <b-col cols="12">
              <label for="email-to" class="form-label"> آخر تقرير سنوي </label>
              <form-file-input
                placeholder="اختر الملف"
                id="document"
                v-model="form.latest_annual_report_doc"
                rules="required"
                accept=".pdf"
              />
            </b-col>
          </b-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              type="submit"
              variant="success"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
    <b-modal
      v-model="mapModal"
      centered
      size="lg"
      title="موقع الفرع"
      footer-class="removed"
      class="edit-modal"
      id="branchModal"
    >
      <map-select
        @closeModal="mapModal = false"
        @markerUpdated="onLocationSelect"
        :govsEndpoint.sync="govEp"
      />
    </b-modal>
  </b-sidebar>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormFile,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  BSidebar,
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import FormMask from "@/components/form-mask";
import { required, integer } from "@validations";
import mapSelect from "@/components/map-select";
import { ValidationProvider } from "vee-validate";
import FormImageInput from "@/components/FormImageInput.vue";
import { quillEditor } from "vue-quill-editor";
import FormFileInput from "@/components/FormFileInput.vue";
const initForm = {};
export default {
  components: {
    formInput,
    formTextarea,
    formSelect,
    BButton,
    BSidebar,
    FormMask,
    saveBtn,
    BRow,
    BCol,
    mapSelect,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormFile,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    FormImageInput , 
    quillEditor ,
    FormFileInput
  },
  props: {
    value: Boolean,
    title: String,
    mainTitle: {
      type: String,
      default: () => "معلومات فرع",
    },
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  data() {
    return {
      form: {},
      required,
      integer,
      govId: null,
      mapModal: false,
      optionsType: [
        { value: 1, title: "مادية" },
        { value: 0, title: "عيني" },
      ],
      editorOption: {
        modules: {
          toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link'],
          ]
        }
      },
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    branchTypes() {
      return this.$store.getters["branch-types/options"];
    },
    govEp() {
      return this.form.branch_type_id &&
        this.branchTypes.find((el) => el.id === this.form.branch_type_id)
          .name_ar === "مكتب"
        ? "v2/selects/branch-related-governorates?related=true"
        : "v2/selects/branch-related-governorates?related=false";
    },
  },
  watch: {
    modalOpen(val) {
      if (val)
        this.$nextTick(() => {
          // this.init(this.intializeForm);
        });
    },
    govId(val) {
      if (val) {
        this.$refs.branchRealEstates.refreshOptions(
          `v2/selects/real-estates?gid=${val}`
        );
        delete this.form.real_estate_id;
      }
    },
    govEp: {
      immediate: true,
      handler(val) {
        if (this.$refs.govs) this.$refs.govs.refreshOptions(val);
      },
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
      if (form.governorate_id) {
        this.govId = form.governorate_id;
        this.form.real_estate_id = form.real_estate_id;
      }
    },
    typeInputHandle(e) {
      this.$delete(this.form, "sub_district_id");
      this.$delete(this.form, "decision_date");
      this.$delete(this.form, "management_committee");
    },
    onLocationSelect(e) {
      this.form.governorate_id = e.govId;
      this.form.longitude = e.pos.lng;
      this.form.latitude = e.pos.lat;
      this.form.sub_district_id = e.area.id;
      this.form.address = e.address;
      this.govId = e.govId;
    },
    async onSubmit() {
      await this.$refs.branchValidation.validate().then(async (success) => {
        if (success) {
          this.$emit("confirm", this.form);
        }
      });
    },
    previewImage(event) {
      var input = event.target.files[0];
      this.form.image = URL.createObjectURL(input);
    },
  },
};
</script>
